import styled from "styled-components"
import media from "styled-media-query"

export const ImageContainer = styled.div`
    flex-shrink: 0;
    height: 320px;

    .gatsby-image-wrapper{
        width: 100%;
        height: 100%;
        -moz-object-fit: cover;
        -webkit-object-fit: cover;
        -ms-object-fit: cover;
        object-fit: cover;
        -moz-object-position: center;
        -webkit-object-position: center;
        -ms-object-position: center;
        object-position: center;
    }


    ${media.lessThan("large")`
        width: 100%;
        height: 320px;

        img {
            width: 100%;
            height: 100%;
        }
    `}

    ${media.lessThan("medium")`
        height: 300px;
    `}

    ${media.lessThan("small")`
        height: 250px;
    `}
    
`